import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { BUILDER } from 'shared/abilities';
import stylesGlobal from '../../../theme/facility-globals.scss';
import { section } from '../decorators';
import style from './HeaderTwoColumn.scss';

const HeaderTwoColumn = ({ children }) => {
  const [topWidget, leftWidget, rightWidget] = React.Children.toArray(children);

  return (
    <div className={stylesGlobal.section}>
      <Container>
        <Row className={`${stylesGlobal.sectionHeader} color-primary-foreground`}>
          <Col xs={12} className={style.headerText}>
            {topWidget}
          </Col>
        </Row>
        <Row className={style.text}>
          <Col sm={6} className={stylesGlobal.columnLeft}>
            {leftWidget}
          </Col>
          <Col sm={6} className={stylesGlobal.columnRight}>
            {rightWidget}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

HeaderTwoColumn.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Text Header 2 Columns', category: 'Text' },
  {
    subsections: [
      { accepts: ['HeaderText'] },
      { accepts: ['ContentBox', 'Accordion'] },
      { accepts: ['ContentBox', 'Accordion'] },
      { accepts: ['EmbedContent', 'StandardUnitListing'] },
      { accepts: ['EmailContactForm', 'ContentBox'] },
      { accepts: ['ContentBox', 'EmailContactForm'] },
    ],
    defaults: [
      'HeaderText',
      'ContentBox',
      'ContentBox',
    ],
  },
)(HeaderTwoColumn);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
